/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Cropper } from 'react-cropper';
import isEmail from 'validator/lib/isEmail';
import {
  TabsContainer,
  TabItem,
  Drawer,
  Button,
  TextInputWithLabel,
  FileUploader,
  Loader
} from 'quantux-ui';
import PayerCardLarge from './payer-card';
import { BASE_URL } from '../../utils';
import { gray, blue, salmon } from '../../theme';

const payerIconSmall = (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Zm12.073-2L3.502 4.857v8.571A8.57 8.57 0 0 0 12.073 22a8.57 8.57 0 0 0 8.571-8.572V4.857L12.073 2Zm0 18.393a6.965 6.965 0 0 0 6.965-6.965V6.063l-6.964-2.455-6.965 2.455v7.366a6.965 6.965 0 0 0 6.965 6.965Z"
      fill="#00A0FF"
    />
  </svg>
);

const AboutPayer = (props) => {
  const [isEditProfileDrawerOpen, setIsEditProfileDrawerOpen] = useState(false);
  // Edit Profile Drawer
  const [activeTab, setActiveTab] = useState(0);
  // Banner and avatar
  const [isBannerCropperDrawerOpen, toggleBannerCropperDrawer] = useState(false);
  const [payerBannerImageUrl, setPayerBannerImageUrl] = useState('https://quantumtrader.s3.amazonaws.com/defaultBanner.svg');
  const [showBannerCropper, setShowBannerCropper] = useState(false);
  const [isBannerUploading, setIsBannerUploading] = useState(false);
  // Avatar cropper drawer
  const [isAvatarCropperDrawerOpen, toggleAvatarCropperDrawer] = useState(false);
  const [payerAvatarImageUrl, setPayerAvatarImageUrl] = useState('https://quantumtrader.s3.amazonaws.com/defaultPayerAvatar.svg');
  const [showAvatarCropper, setShowAvatarCropper] = useState(false);
  const [isAvatarUploading, setIsAvatarUploading] = useState(false);
  //
  const [payerUsername, setPayerUsername] = useState('');
  const [isPayerUserNameValid, setIsPayerUserNameValid] = useState(true);
  const [isPayerUserNameDuplicate, setIsPayerUserNameDuplicate] = useState(false);
  const [isPayerUserNamePristine, setIsPayerUserNamePristine] = useState(true);
  const [payerStreetAddress, setPayerStreetAddress] = useState('');
  const [isPayerPhoneValid, checkPayerPhoneValidity] = useState(false);
  const [isPayerPhonePristine, setPayerPhonePristineState] = useState(true);
  const [payerSuite, setPayerSuite] = useState('');
  const [payerCity, setPayerCity] = useState('');
  const [payerState, setPayerState] = useState('');
  const [payerZip, setPayerZip] = useState('');
  const [payerPhone, setPayerPhone] = useState('');
  const [payerFax, setPayerFax] = useState('');
  const [payerWebsite, setPayerWebsite] = useState('');
  const [payerEmail, setPayerEmail] = useState('');
  const [isPayerEmailPristine, setIsPayerEmailPristine] = useState(true);
  const [isPayerEmailValid, setIsPayerEmailValid] = useState(true);

  const editProfileTabsContainer = useRef();
  const drawerBannerRef = useRef();
  const drawerAvatarRef = useRef();
  const bannerCropperRef = useRef();
  const bannerFileInputRef = useRef();
  const avatarCropperRef = useRef();
  const avatarFileInputRef = useRef();

  // Username validity and duplicate check
  // useEffect(() => {
  //   const isValid = payerUsername.length >= 2 && payerUsername.length <= 20 && payerUsername.indexOf(' ') < 0;
  //   setIsPayerUserNameValid(isValid);

  //   if (isValid) {
  //     const formData = new FormData();
  //     formData.append('id', props.data._id);
  //     formData.append('newUsername', payerUsername);

  //     const reqHeaders = new Headers();
  //     const token = localStorage.getItem('token');
  //     reqHeaders.append('Authorization', `Bearer ${token}`);
  //     const requestOptions = {
  //       method: 'POST',
  //       body: formData,
  //       redirect: 'follow',
  //       headers: reqHeaders
  //     };

  //     fetch(`${BASE_URL}/payers/checkUniqueUsername`, requestOptions)
  //       .then(response => response.text())
  //       .then(result => {
  //         const res = JSON.parse(result);
  //         console.log(res);
  //         if (res.success) {
  //           setIsPayerUserNameDuplicate(res.isDuplicate);
  //         } else {
  //           setIsPayerUserNameDuplicate(true);
  //         }
  //       })
  //       .catch(error => {
  //         console.log('error', error);
  //       });
  //   }
  // }, [payerUsername]);

  useEffect(() => {
    setIsPayerEmailValid(isEmail(payerEmail));
  }, [payerEmail]);

  const styles = StyleSheet.create({
    aboutContainer: {
      width: '359px',
      height: '323px',
      minHeight: '323px',
      // minHeight: '400px',
      // background: gray[500],
      background: blue[800],
      borderRadius: '4px',
      padding: '8px',
      color: gray[200],
      fontSize: '14px',
      fontWeight: '700'
    },
    headingText: {
      fontSize: '14px',
      marginLeft: '8px',
      minWidth: '250px',
      maxWidth: '250px',
      paddingRight: '4px'
    },
    headingTitle: {
      fontWeight: 'bold'
    },
    headingUsername: {
      color: blue[500]
    },
    headingPayerCode: {
      color: 'white'
    },
    ellipsisContainer: {
      width: '20px',
      height: '20px',
      minWidth: '20px',
      minHeight: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: blue[200],
      borderRadius: '4px',
      color: blue[800]
    },
    apwItem: {
      display: 'flex',
      alignItems: 'center'
    },
    apwError: {
      color: salmon[500]
    },
    apwIconContainer: {
      width: '24px'
    },
    apwIcon: {
      fontSize: '28px'
    },
    transactionContainer: {
      marginTop: '16px',
      display: 'flex'
    },
    transactionCol: {
      flexGrow: '1'
    },
    transactionColHeading: {
      fontSize: '16px',
      fontWeight: 'bold'
    },
    transcationColList: {
      paddingLeft: '16px',
      marginTop: '4px',
      marginBottom: '8px'
    },
    // --- for edit profile drawers
    profileBanner: {
      borderBottom: '1px solid transparent'
    },
    profileBannerImg: {
      width: '100%',
      height: 'auto',
      maxHeight: '220px'
    },
    bigUserCardContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: '1px solid transparent'
    },
    userCard: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '80px',
      height: '80px',
      // background: '#0080FF',
      borderRadius: '4px'
    },
    userCardIcon: {
      color: 'white',
      fontSize: '70px'
    },
    userCardAvatarImg: {
      width: 'auto',
      height: '80px',
      maxHeight: '80px',
      borderRadius: '4px'
    },
    userCardDisplayName: {
      color: blue[500]
    },
    userCardEllipsisMenuBtn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#60A0E0',
      height: '24px',
      width: '24px',
      borderRadius: '50%',
      color: '#001824',
      position: 'relative'
    },
    popupMenuContainer: {
      background: '#083050',
      width: '150px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)'
    },
    popupMenuItem: {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      color: '#5080B0'
    },
    menuItemIconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '40px',
      width: '40px'
    },
    menuItemIcon: {
      fontSize: '20px'
    },
    drawerContainer: {
      background: gray[800],
      color: gray[300],
      height: '100%',
      position: 'relative',
      display: 'flex',
      flexFlow: 'column'
    },
    drawerHeader: {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 8px',
      fontWeight: 'bold',
      borderBottom: '1px solid black',
      flexShrink: '0'
    },
    drawerHeaderCloseIcon: {
      color: gray[300],
      ':hover': {
        color: salmon[500]
      }
    },
    drawerBanner: {
      position: 'relative',
      padding: '8px',
      flexShrink: '0'
    },
    drawerBannerImg: {
      width: '100%',
      height: 'auto'
    },
    drawerBannerCameraIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: gray[500],
      color: 'white',
      position: 'absolute',
      right: '0',
      bottom: '8px',
      fontSize: '11px',
      width: '24px',
      height: '24px',
      cursor: 'pointer',
      borderRadius: '50%'
    },
    drawerContentArea: {
      // height: 'calc(100vh - 186px)',
      overflowY: 'auto',
      color: gray[300],
      flexGrow: '1'
    },
    drawerUserCardAvatar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '80px',
      height: '80px',
      // background: blue[500],
      color: 'white',
      borderRadius: '4px',
      position: 'relative'
    },
    drawerUserCardAvatarImg: {
      width: 'auto',
      height: '80px',
      maxHeight: '80px'
    },
    drawerAvatarCamera: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: gray[500],
      color: 'white',
      position: 'absolute',
      left: '-3px',
      top: '58px',
      fontSize: '11px',
      width: '24px',
      height: '24px',
      cursor: 'pointer',
      borderRadius: '50%'
    },
    drawerUserCardText: {
      fontSize: '12px'
    },
    profileTextAreaContainer: {
      paddingRight: '8px'
    },
    profileTextArea: {
      width: '100%',
      background: gray[900],
      height: '100px',
      color: gray[100],
      border: 'none',
      resize: 'none',
      overflow: 'auto',
      fontFamily: 'Lato',
      padding: '8px',
      ':focus': {
        outlineColor: 'transparent',
        outlineStyle: 'none'
      }
    },
    drawerFooter: {
      alignItems: 'center',
      justifyContent: 'flex-end',
      background: gray[700],
      height: '56px',
      width: '100%',
      borderTop: `1px solid ${gray[500]}`,
      // position: 'absolute',
      // top: 'calc(100vh - 56px)',
      flexShrink: '0'
    },
    imageUploaderContainer: {
      position: 'relative',
      maxHeight: '454px'
    },
    imageUploadLoader: {
      position: 'relative',
      height: '454px',
      top: '-400px',
      background: gray[800]
    },
    practiceOwnerRemoveBtn: {
      fontSize: '20px',
      ':hover': {
        color: salmon[500]
      }
    },
    practiceOwnerCard: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '8px',
      background: '#0A3250',
      borderRadius: '5px',
      padding: '8px'
    },
    errMsg: {
      color: '#FF6060',
      fontSize: '12px'
    }
  });

  const {
    payerName,
    address = {},
    phone = '',
    fax = '',
    website = '',
    email = '',
    servicingStates = ''
  } = props.data;

  let pWebsite = '';
  if (website.indexOf('://') === -1) {
    pWebsite = `http://${website}`;
  } else {
    pWebsite = website;
  }

  let pPhoneUrl = '';
  if (phone.length > 0) {
    const tmp = phone.replace(/-/g, '');
    pPhoneUrl = `tel:+1${tmp}`;
  }

  let pAddressUrl = ''
  if (address.streetAddress1) {
    const tmpAddress = `${address.streetAddress1} ${address.city} ${address.state} ${address.zip.substring(0, 5)}`;
    pAddressUrl = 'https://www.google.com/maps/search/?api=1&query=' + encodeURI(tmpAddress);
  }

  const openEditProfileDrawer = () => {
    const { data } = props;
    setPayerBannerImageUrl(data.bannerImageUrl || 'https://quantumtrader.s3.amazonaws.com/defaultBanner.svg');
    setPayerAvatarImageUrl(data.avatarImageUrl || 'https://quantumtrader.s3.amazonaws.com/defaultPayerAvatar.svg');
    // setPayerUsername(data.userName);
    setPayerStreetAddress(data.address ? data.address.streetAddress1 : '');
    setPayerSuite(data.address ? data.address.suite : '');
    setPayerCity(data.address ? data.address.city : '');
    setPayerState(data.address ? data.address.state : '');
    setPayerZip(data.address ? data.address.zip : '');
    setPayerEmail(data.email ? data.email : '');
    setPayerPhone(data.phone || '');
    setPayerFax(data.fax || '');
    setPayerWebsite(data.website || '');
    setShowAvatarCropper(false);
    setIsAvatarUploading(false);
    setShowBannerCropper(false);
    setIsBannerUploading(false);

    setIsEditProfileDrawerOpen(true);
  };

  const closeEditProfileDrawer = () => {
    setIsEditProfileDrawerOpen(false);
  };

  // #region Edit profile drawer handlers
  const handleOnEditStreetAddress = (e) => {
    const { value } = e.target;
    setPayerStreetAddress(value);
  };

  const handleOnEditSuite = (e) => {
    const { value } = e.target;
    setPayerSuite(value);
  };

  const handleOnEditCity = (e) => {
    const { value } = e.target;
    setPayerCity(value);
  };

  const handleOnEditState = (e) => {
    const { value } = e.target;
    setPayerState(value);
  };

  const handleOnEditZip = (e) => {
    const { value } = e.target;
    setPayerZip(value);
  };

  const handleOnEditPhone = (e) => {
    const { value } = e.target;
    setPayerPhone(value);
  };

  const handleOnEditFax = (e) => {
    const { value } = e.target;
    setPayerFax(value);
  };

  const handleOnEditWesbite = (e) => {
    const { value } = e.target;
    setPayerWebsite(value);
  };

  const handleOnEditEmail = (e) => {
    const { value } = e.target;
    setPayerEmail(value);
    setIsPayerEmailPristine(false);
  };

  const handleOnClickSavePayerProfile = () => {
    const formData = new FormData();
    formData.append('id', props.data._id);
    formData.append('payerAvatarImageUrl', payerAvatarImageUrl);
    formData.append('payerBannerImageUrl', payerBannerImageUrl);
    // formData.append('userName', payerUsername);
    formData.append('streetAddress', payerStreetAddress.trim());
    formData.append('suite', payerSuite.trim());
    formData.append('city', payerCity.trim());
    formData.append('state', payerState.trim());
    formData.append('zip', payerZip.trim());
    formData.append('email', payerEmail.trim());
    formData.append('website', payerWebsite.trim());
    // Payer Phone
    let phone = payerPhone.startsWith('1') ? payerPhone.substring(1) : payerPhone;
    phone = phone.replace(/-/g, '');
    formData.append('phone', phone);
    // Payer Fax
    let fax = payerFax.startsWith('1') ? payerFax.substring(1) : payerFax;
    fax = fax.replace(/-/g, '');
    formData.append('fax', fax);

    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);
    const requestOptions = {
      method: 'POST',
      body: formData,
      redirect: 'follow',
      headers: reqHeaders
    };

    fetch(`${BASE_URL}/payers2/updatePayerProfile`, requestOptions)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        if (res.success) {
          setIsEditProfileDrawerOpen(false);
          props.reloadData();
        }
      })
      .catch(error => {
        console.log('error', error);
      });
  };
  // #endregion

  // #region Banner cropper drawer handlers
  const handleOnBannerFileDrop = (img) => {
    const formData = new FormData();
    formData.append('file', img);
    const options = { method: 'POST', body: formData, redirect: 'follow' };
    setIsBannerUploading(true);
    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        // console.log(res);
        if (res.success) {
          setPayerBannerImageUrl(res.fileUrl);
          setIsBannerUploading(false);
          setShowBannerCropper(true);
        }
      })
      .catch(error => console.log('error', error));
  };

  const uploadBanner = () => {
    const formData = new FormData();
    const img = bannerFileInputRef.current.files[0];
    formData.append('file', img);
    const options = { method: 'POST', body: formData, redirect: 'follow' };

    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        console.log(res);
        if (res.success) {
          setPayerBannerImageUrl(res.fileUrl);
          setIsBannerUploading(false);
          setShowBannerCropper(true);
        }
      })
      .catch(error => console.log('error', error));
  };

  const handleOnBannerFileSelected = () => {
    if (bannerFileInputRef.current.files.length > 0) {
      setIsBannerUploading(true);
      uploadBanner();
    } else {
      console.log('No file is selected!');
    }
  };

  const uploadCroppedBanner = (blob) => {
    const formData = new FormData();
    formData.append('file', blob, 'croppedBanner.png');
    const options = { method: 'POST', body: formData, redirect: 'follow' };

    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        // console.log(res);
        if (res.success) {
          // console.log('Cropped banner image url', res.fileUrl);
          setPayerBannerImageUrl(res.fileUrl);
        }
      })
      .catch(error => console.log('error', error));
  };

  const handleOnClickBannerCrop = () => {
    const imageElement = bannerCropperRef.current;
    const { cropper } = imageElement;
    cropper.getCroppedCanvas().toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      drawerBannerRef.current.src = url;
      uploadCroppedBanner(blob);
      toggleBannerCropperDrawer(false);
    });
  };
  // #endregion

  // #region Avatar cropper drawer handlers
  const handleOnAvatarFileDrop = (img) => {
    const formData = new FormData();
    formData.append('file', img);
    const options = { method: 'POST', body: formData, redirect: 'follow' };
    setIsAvatarUploading(true);
    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        // console.log(res);
        if (res.success) {
          setPayerAvatarImageUrl(res.fileUrl);
          setIsAvatarUploading(false);
          setShowAvatarCropper(true);
        }
      })
      .catch(error => console.log('error', error));
  };

  const uploadAvatar = () => {
    const formData = new FormData();
    const img = avatarFileInputRef.current.files[0];
    formData.append('file', img);
    const options = { method: 'POST', body: formData, redirect: 'follow' };

    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        console.log(res);
        if (res.success) {
          setPayerAvatarImageUrl(res.fileUrl);
          setIsAvatarUploading(false);
          setShowAvatarCropper(true);
        }
      })
      .catch(error => console.log('error', error));
  };

  const handleOnAvatarFileSelected = () => {
    if (avatarFileInputRef.current.files.length > 0) {
      setIsAvatarUploading(true);
      uploadAvatar();
    } else {
      console.log('No file is selected!');
    }
  };

  const uploadCroppedAvatar = (blob) => {
    const formData = new FormData();
    formData.append('file', blob, 'croppedAvatar.png');
    const options = { method: 'POST', body: formData, redirect: 'follow' };

    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        // console.log(res);
        if (res.success) {
          // console.log('Cropped banner image url', res.fileUrl);
          setPayerAvatarImageUrl(res.fileUrl);
        }
      })
      .catch(error => console.log('error', error));
  };

  const handleOnClickAvatarCrop = () => {
    const imageElement = avatarCropperRef.current;
    const { cropper } = imageElement;
    cropper.getCroppedCanvas().toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      drawerAvatarRef.current.src = url;
      uploadCroppedAvatar(blob);
      toggleAvatarCropperDrawer(false);
    });
  };
  // #endregion

  // Tab Items
  const payerInfoTab = (
    <div className='p-1'>
      {/* Banner */}
      <div className={css(styles.drawerBanner)}>
        <img
          ref={drawerBannerRef}
          src={payerBannerImageUrl}
          alt="cropped-banner"
          className={css(styles.drawerBannerImg)}
        />
        {/* Camera icon */}
        <div
          className={css(styles.drawerBannerCameraIcon)}
          onClick={() => {
            toggleBannerCropperDrawer(true);
            console.log('opening ... banner cropper drawer')
          }}
        >
          <i className="fa fa-camera" />
        </div>
      </div>
      {/* Middle area */}
      <div className={css(styles.drawerContentArea)}>
        {/* User card */}
        <div className="fx ml-2">
          {/* Avatar */}
          <div className={css(styles.drawerUserCardAvatar)}>
            <img
              src={payerAvatarImageUrl}
              ref={drawerAvatarRef}
              alt="avatar"
              className={css(styles.drawerUserCardAvatarImg)}
              onClick={() => toggleAvatarCropperDrawer(true)}
            />
            <div
              onClick={() => { toggleAvatarCropperDrawer(true); }}
              className={css(styles.drawerAvatarCamera)}
            >
              <i className="fa fa-camera" />
            </div>
          </div>
          {/* User card displayName & userName */}
          <div className={`ml-2 ${css(styles.drawerUserCardText)}`}>
            {/* Name and Npi */}
            <div style={{ fontSize: '12px', color: gray[200], lineHeight: '12px', paddingLeft: '2px' }}>
              {payerName !== '' ? payerName : ''}
            </div>
            {/* Payer Username */}
            {/* <div>
              <TextInputWithLabel
                value={payerUsername}
                titleText="Username (2 to 20 characters, no spaces)"
                titleFontSize={12}
                isCompactLayout={true}
                titleColor={gray[200]}
                textColor={blue[500]}
                selectionColor="white"
                selectionBackground="#0080FF"
                spellcheck={false}
                width={248}
                onChange={handleOnEditUserName}
              />
              {!isPayerUserNameValid && !isPayerUserNamePristine
                ? <div
                  style={{
                    color: '#FF6060',
                    fontSize: '12px'
                  }}
                >
                  Invalid User Name
                </div>
                : null
              }
              {!isPayerUserNamePristine && isPayerUserNameDuplicate && isPayerUserNameValid
                ? <div
                  style={{
                    color: '#FF6060',
                    fontSize: '12px'
                  }}
                >
                  User Name Taken
                </div>
                : null
              }
            </div> */}
          </div>
        </div>
        {/* Middle area */}
        <div className="mt-4 ml-2">
          {/* Mailing address heading */}
          <div className="fx fx__v-center">
            <i className="fa fa-map-marker" style={{ fontSize: '28px' }} />
            <div className="ml-2">
              Address
            </div>
          </div>
          {/* Form */}
          <div>
            {/* Street address & suite */}
            <div className="fx">
              <div>
                <TextInputWithLabel
                  value={payerStreetAddress}
                  titleText="Street"
                  titleFontSize={12}
                  isCompactLayout={true}
                  titleColor={gray[200]}
                  textColor="white"
                  selectionColor="white"
                  selectionBackground="#0080FF"
                  spellcheck={false}
                  width={284}
                  onChange={handleOnEditStreetAddress}
                />
              </div>
              <div className="ml-2">
                <TextInputWithLabel
                  value={payerSuite}
                  titleText="Suite"
                  titleFontSize={12}
                  isCompactLayout={true}
                  titleColor={gray[200]}
                  textColor="white"
                  selectionColor="white"
                  selectionBackground="#0080FF"
                  spellcheck={false}
                  width={45}
                  onChange={handleOnEditSuite}
                />
              </div>
            </div>
            {/* City, State and Zip */}
            <div className="fx mt-2">
              <div>
                <TextInputWithLabel
                  value={payerCity}
                  titleText="City"
                  titleFontSize={12}
                  isCompactLayout={true}
                  titleColor={gray[200]}
                  textColor="white"
                  selectionColor="white"
                  selectionBackground="#0080FF"
                  spellcheck={false}
                  width={230}
                  onChange={handleOnEditCity}
                />
              </div>
              <div className="ml-2">
                <TextInputWithLabel
                  value={payerState}
                  titleText="State"
                  titleFontSize={12}
                  isCompactLayout={true}
                  titleColor={gray[200]}
                  textColor="white"
                  selectionColor="white"
                  selectionBackground="#0080FF"
                  spellcheck={false}
                  width={45}
                  onChange={handleOnEditState}
                />
              </div>
              <div className="ml-2">
                <TextInputWithLabel
                  value={payerZip}
                  titleText="Zip"
                  titleFontSize={12}
                  isCompactLayout={true}
                  titleColor={gray[200]}
                  textColor="white"
                  selectionColor="white"
                  selectionBackground="#0080FF"
                  spellcheck={false}
                  width={45}
                  onChange={handleOnEditZip}
                />
              </div>
            </div>
            {/* Phone */}
            <div className="mt-2">
              <TextInputWithLabel
                value={payerPhone}
                titleText="Phone"
                titleFontSize={12}
                titleColor={gray[200]}
                textColor="white"
                selectionColor="white"
                selectionBackground="#0080FF"
                spellcheck={false}
                width={337}
                onChange={handleOnEditPhone}
                // isCompactLayout={false}
                // showPreIcon
                // preIcon='fa fa-phone'
              />
              {!isPayerPhonePristine && !isPayerPhoneValid
                ? <div className={css(styles.errMsg)}>Invalid Phone #</div>
                : null
              }
            </div>
            {/* Fax */}
            <div className="mt-2">
              <TextInputWithLabel
                value={payerFax}
                titleText="Fax"
                titleFontSize={12}
                titleColor={gray[200]}
                textColor="white"
                selectionColor="white"
                selectionBackground="#0080FF"
                spellcheck={false}
                width={337}
                onChange={handleOnEditFax}
                // isCompactLayout={false}
                // showPreIcon
                // preIcon='fa fa-fax'
              />
            </div>
            {/* Website */}
            <div className="mt-2">
              <TextInputWithLabel
                value={payerWebsite}
                titleText="Website"
                titleFontSize={12}
                titleColor={gray[200]}
                textColor="white"
                selectionColor="white"
                selectionBackground="#0080FF"
                spellcheck={false}
                width={337}
                onChange={handleOnEditWesbite}
                // isCompactLayout={false}
                // showPreIcon
                // preIcon='fa fa-globe'
              />
            </div>
            {/* Email */}
            <div className="mt-2">
              <TextInputWithLabel
                value={payerEmail}
                titleText="Email"
                titleFontSize={12}
                titleColor={gray[200]}
                textColor="white"
                selectionColor="white"
                selectionBackground="#0080FF"
                spellcheck={false}
                width={337}
                onChange={handleOnEditEmail}
                // isCompactLayout={false}
                // showPreIcon
                // preIcon='fa fa-globe'
              />
              {!isPayerEmailPristine && !isPayerEmailValid
                ? <div className={css(styles.errMsg)}>Invalid Email</div>
                : null
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const payerManagersTab = (
    <div className='p-4'>
      Placeholder
    </div>
  );

  console.log(props.data);

  return (
    <div className='p-4'>
      {isEditProfileDrawerOpen &&
        <Drawer
          placement="right"
          visible={isEditProfileDrawerOpen}
          toggleDrawer={closeEditProfileDrawer}
          zIndex="2000"
          width={window.innerWidth <= 700 ? window.innerWidth : 358}
        >
          <div className={css(styles.drawerContainer)}>
            {/* Header */}
            <div className={css(styles.drawerHeader)}>
              <div className='fx fx__hv-center'>
                {payerIconSmall}
                <div className='ml-2'>Payer Profile</div>
              </div>
              <i
                className={`fa fa-lg fa-times-circle ${css(styles.drawerHeaderCloseIcon)}`}
                onClick={closeEditProfileDrawer}
              />
            </div>
            {/* Tabs */}
            <div ref={editProfileTabsContainer}>
              <TabsContainer
                dropDownId="d1"
                showPlusIcon={false}
                shiftMethod='availableWidth'
                containerWidth={editProfileTabsContainer && editProfileTabsContainer.current ? editProfileTabsContainer.current.getBoundingClientRect().width : 230}
                otherElementsWidth={0}
                minWidth={206}
                dropDownTop={39}
                dropDownLeft={44}
                dropDownHeaderStyles={{
                  minWidth: '170px',
                  maxWidth: '370px',
                  width: '100%'
                }}
                containerStyles={{
                  width: '100%'
                }}
              >
                <TabItem
                  tabKey="1"
                  key='9898'
                  parentKey="0111"
                  text="Facility Info"
                  isActive={activeTab === 0}
                  iconClass='fa fa-info-circle'
                  style={{
                    paddingRight: '0',
                    width: '130px',
                    minWidth: '130px',
                    maxWidth: '130px'
                  }}
                  textStyles={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                  onActivate={() => {
                    setActiveTab(0);
                  }}
                >
                  <div>
                    Payer Info
                  </div>
                </TabItem>
                <TabItem
                  tabKey="2"
                  key='9899'
                  parentKey="0111"
                  text="Facility Users"
                  isActive={activeTab === 1}
                  iconClass='fa fa-users'
                  style={{
                    paddingRight: '0',
                    width: '200px',
                    minWidth: '200px',
                    maxWidth: '200px'
                  }}
                  textStyles={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                  onActivate={() => {
                    setActiveTab(1);
                  }}
                >
                  <div>
                    Profile Managers
                  </div>
                </TabItem>
              </TabsContainer>
            </div>
            {/* Active tab */}
            <div className={css(styles.drawerContentArea)}>
              {activeTab === 0 ? payerInfoTab : payerManagersTab}
            </div>
            {/* Footer */}
            <div className={`fx pr-2 ${css(styles.drawerFooter)}`} >
              <Button
                btnType="primary"
                isDisabled={isPayerUserNameDuplicate || !isPayerUserNameValid}
                className="fx fx__hv-center"
                onClick={handleOnClickSavePayerProfile}
                style={{
                  height: '32px',
                  width: '340px',
                  padding: '3px 0'
                }}
              >
                Save Payer Profile
              </Button>
            </div>
          </div>
        </Drawer>
      }
      {/* Banner upload drawer */}
      {isBannerCropperDrawerOpen &&
        <Drawer
          placement="right"
          visible={isBannerCropperDrawerOpen}
          toggleDrawer={() => toggleBannerCropperDrawer(false)}
          zIndex="2050"
          width={window.innerWidth <= 700 ? window.innerWidth : 358}
        >
          <div className={css(styles.drawerContainer)}>
            {/* Header */}
            <div className={css(styles.drawerHeader)}>
              <div>Upload Payer Banner</div>
              <i
                className={`fa fa-times-circle ${css(styles.drawerHeaderCloseIcon)}`}
                onClick={() => { toggleBannerCropperDrawer(false); }}
              />
            </div>
            {/* Content Area */}
            <div className={css(styles.drawerContentArea, styles.imageUploaderContainer)}>
              {showBannerCropper
                ? <div>
                  <Cropper
                    src={payerBannerImageUrl}
                    style={{ height: 400, width: '100%' }}
                    checkCrossOrigin
                    checkOrientation={false}
                    aspectRatio={6}
                    background={false}
                    viewMode={1}
                    autoCropArea={1}
                    guides={false}
                    ref={bannerCropperRef}
                  />
                </div>
                : null
              }
              {!showBannerCropper
                ? <div>
                  <FileUploader
                    title='Select Photo'
                    parentRef={bannerFileInputRef}
                    onDrop={handleOnBannerFileDrop}
                    onChange={handleOnBannerFileSelected}
                  />
                </div>
                : null
              }
              {isBannerUploading
                ? <div className={css(styles.imageUploadLoader)}>
                  <Loader iconType="cog" iconSize="5x" text="Uploading Banner Image" />
                </div>
                : null
              }
            </div>
            {/* Drawer footer area */}
            <div
              className={`fx pr-2 ${css(styles.drawerFooter)}`}
              style={{ position: 'absolute', bottom: '0' }}
            >
              <Button
                btnType="primary"
                className="fx fx__hv-center"
                onClick={handleOnClickBannerCrop}
                style={{
                  height: '32px',
                  width: '340px',
                  padding: '3px 0'
                }}
              >
                Crop Banner Image
              </Button>
            </div>
          </div>
        </Drawer>
      }

      {/* Avatar upload drawer */}
      {isAvatarCropperDrawerOpen &&
        <Drawer
          placement="right"
          visible={isAvatarCropperDrawerOpen}
          toggleDrawer={() => toggleAvatarCropperDrawer(false)}
          zIndex="2050"
          width={window.innerWidth <= 700 ? window.innerWidth : 358}
        >
          <div className={css(styles.drawerContainer)}>
            {/* Header */}
            <div className={css(styles.drawerHeader)}>
              <div>Upload Payer Avatar</div>
              <i
                className={`fa fa-times-circle ${css(styles.drawerHeaderCloseIcon)}`}
                onClick={() => { toggleAvatarCropperDrawer(false); }}
              />
            </div>
            {/* Content Area */}
            <div className={css(styles.drawerContentArea, styles.imageUploaderContainer)}>
              {showAvatarCropper
                ? <div>
                  <Cropper
                    src={payerAvatarImageUrl}
                    style={{ height: 400, width: '100%' }}
                    checkCrossOrigin
                    checkOrientation={false}
                    aspectRatio={1}
                    background={false}
                    viewMode={1}
                    autoCropArea={1}
                    guides={false}
                    ref={avatarCropperRef}
                  />
                </div>
                : null
              }
              {!showAvatarCropper
                ? <div>
                  <FileUploader
                    title='Select Photo'
                    parentRef={avatarFileInputRef}
                    onDrop={handleOnAvatarFileDrop}
                    onChange={handleOnAvatarFileSelected}
                  />
                </div>
                : null
              }
              {isAvatarUploading
                ? <div className={css(styles.imageUploadLoader)}>
                  <Loader iconType="cog" iconSize="5x" text="Uploading Avatar" />
                </div>
                : null
              }
            </div>
            {/* Drawer footer area */}
            <div
              className={`fx pr-2 ${css(styles.drawerFooter)}`}
              style={{ position: 'absolute', bottom: '0' }}
            >
              <Button
                btnType="primary"
                className="fx fx__hv-center"
                onClick={handleOnClickAvatarCrop}
                style={{
                  height: '32px',
                  width: '340px',
                  padding: '3px 0'
                }}
              >
                Crop Avatar Image
              </Button>
            </div>
          </div>
        </Drawer>
      }

      {/* About Payer Card */}
      <PayerCardLarge
        data={props.data}
        handleOnClickEllipsis={openEditProfileDrawer}
      />
    </div>
  );
};

export default AboutPayer;
